/**
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
   NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private
   Limited. Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is
   obtained from Robert Bosch Engineering and Business Solutions Private Limited.
*/

import { Pipe, PipeTransform } from '@angular/core';

/**
  * @ngdoc component
  * @name SharedModule.component:AppendSpacePipe
  *
  *
  * @description
  * description: To convert backend keys to meaningful readable names for the table column headings
  *
*/
@Pipe({ name: 'appendSpace' })
export class AppendSpacePipe implements PipeTransform {

    /**
      * @ngdoc method
      * @name AppendSpacePipe#transform
      *
      * @methodOf
      * SharedModule.controller:AppendSpacePipe
      *
      * @description
      * Description: To convert backend keys to meaningful readable names for the table column headings
      *
      * @param {type} name description: key received from backend
      * @return {type} name description: meaningful readable names for the table column name
    */
    public transform(str: string): any {
        if (str) {
            return str.replace(/([A-Z])/g, ' $1').trim();
        }
        return null;
    }
}
